import React from "react";
import circle from '@turf/circle'
import {GoogleMap, Polygon, Marker, OverlayView } from '@react-google-maps/api'
import pin from "../../../../assets/img/placeholder.svg"

const containerStyle = {
    width: '100%',
    height: '400px'
};


const MapComponent = props => {

    const {onClick, polygon, add, zoom, places, center} = props

    return (
        <>

            <GoogleMap zoom={zoom} center={center}
                       mapContainerStyle={containerStyle}
                       onClick={ev => onClick(ev.latLng.lat(), ev.latLng.lng())}
            >
                {places.map((place) => {
                    return (
                        <div key={place.ID}>
                            <Marker key={place.ID}
                                    icon={{
                                        url: pin,
                                        origin: new window.google.maps.Point(0, 0),
                                        anchor: new window.google.maps.Point(15, 15),
                                        scaledSize: new window.google.maps.Size(30, 30),
                                    }}
                                    position={{lat: place.latitude, lng: place.longitude}}/>

                            <OverlayView
                                position={{lat: place.latitude, lng: place.longitude}}
                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                            >
                                <div style={style.overlayStyle}>
                                    <span>{place.zone}</span>
                                </div>
                            </OverlayView>
                        </div>
                    )
                })}

                {(polygon && !add) && <Polygon
                    paths={polygon}
                    options={{
                        fillColor: "#01A0EC",
                        fillOpacity: 0.4,
                        strokeColor: '#1A5588',
                        strokeOpacity: 1,
                        strokeWeight: 1
                    }}/>}

                {places.map((zone, i) => {
                    const center = [zone.longitude, zone.latitude];
                    const options = {
                        steps: 25,
                        units: 'kilometers',
                        options: {}
                    }

                    const polygon = circle(center, zone.radius, options);
                    const poly = polygon.geometry.coordinates

                    const polyArray = []
                    poly.forEach(items => {
                        items.forEach(item => {
                            const obj = {lat: item[1], lng: item[0]}
                            polyArray.push(obj)
                        })
                    })
                    return (
                        <Polygon
                            key={i}
                            paths={polyArray}
                            options={{
                                fillColor: "#ec407a",
                                fillOpacity: 0.4,
                                strokeColor: '#e91e63',
                                strokeOpacity: 1,
                                strokeWeight: 1
                            }}
                        />
                    )
                })}
            </GoogleMap>
        </>
    );
};

export default MapComponent

const style = {
    overlayStyle: {
        width: 50,
        height: 10,
        background: 'rgba(255, 255, 255, 0.8)',
        padding: 5,
        display: "flex",
        flexDirection: 'center',
        alignItems: "center",
        border: '1px solid #333',
        borderRadius: 5,
        marginTop: 15,
    }

}
